import i18n from "i18next";
import LanguageDetector, { type DetectorOptions } from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import { ENV } from "@/shared/config/env";
import { STORAGE_KEYS } from "@/shared/constants/storage-keys";

const languageDetectorOptions: DetectorOptions = {
  order: ["localStorage", "navigator"],
  caches: ["localStorage"],
  lookupLocalStorage: STORAGE_KEYS.locale,
  convertDetectedLanguage: normalizeLocale,
};

const localeModules = import.meta.glob("../../locales/**/*.json", { eager: true });

type LocaleResourceModule = {
  default?: Record<string, string | object>;
};

const resources = Object.entries(localeModules).reduce<
  Record<string, Record<string, Record<string, string | object>>>
>((accumulator, [path, module]) => {
  const match = path.match(/\.\.\/\.\.\/locales\/([^/]+)\/([^/]+)\.json$/);

  if (!match) {
    return accumulator;
  }

  const [, locale, namespace] = match;
  const resource = (module as LocaleResourceModule).default ?? {};

  accumulator[locale] ??= {};
  accumulator[locale][namespace] = resource;

  return accumulator;
}, {});

const supportedLocales = Object.keys(resources);

function normalizeLocale(lng: string): string {
  if (!lng) return ENV.defaultLocale;
  if (lng.startsWith("zh-CN")) return "zh-CN";
  if (lng.startsWith("zh-TW") || lng.startsWith("zh-HK")) return "zh-TW";
  if (lng.startsWith("en")) return "en-US";
  return lng;
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: normalizeLocale(ENV.defaultLocale),
    supportedLngs: supportedLocales,
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    ns: ["common", "errors", "login", "onboarding", "reset-password", "signup"],
    defaultNS: "common",
    detection: languageDetectorOptions,
  });

export default i18n;
